import React from "react";
import Footer from "@/bit/components/components.footer";
import Header from "@/bit/components/components.header";
import MetaData from "@/bit/core/core.meta-data";
import { wrapper } from "@/store";
import { getStaticProps as getStaticPropsMethod } from "@/bit/pages/pages.create-pages";
import CustomizerComponent from "@/bit/components/components.customizer-component";
import ExpandableList from "@/bit/components/components.expandable-list";
import DevicesOffers from "@/component/devices-offers";
import FeaturedCarousel from "@/component/featured-carousel";
import Card from "@/component/card";
import Text from "@/bit/components/components.text";
import SuperBanner from "@/component/superbanner";

class BF extends React.Component {
  render() {
    const {
      breadcrumbsProps,
      headerProps,
      seoInfo,
      footerProps,
      custoPageInfo,
    } = this.props;

    const keys = custoPageInfo && Object.keys(custoPageInfo);
    const title = custoPageInfo[keys[0]];
    const superBanner = custoPageInfo[keys[1]];    
    const hero1 = custoPageInfo[keys[2]];
    const hero2 = custoPageInfo[keys[3]];
    const hero3 = custoPageInfo[keys[4]];
    const offer1 = custoPageInfo[keys[5]];
    const offer2 = custoPageInfo[keys[6]];
    const offer3 = custoPageInfo[keys[7]];
    const r2rTitle = custoPageInfo[keys[8]];
    const r2r = custoPageInfo[keys[9]];
    const categories = custoPageInfo[keys[10]];
    const brands = custoPageInfo[keys[11]];
    const faqs = custoPageInfo[keys[12]];

    return (
      <>
        <MetaData seoInfo={seoInfo} />
        <Header {...breadcrumbsProps} {...headerProps} />

        {title && (
          <div className="title container">
            <div>
              <div>
                <CustomizerComponent
                  name={title.activityName}
                  Component={Text}
                  componentProps={title}
                  componentName="title"
                />
              </div>
            </div>
          </div>
        )}

        {superBanner && (        
            <CustomizerComponent
              name={superBanner.activityName}
              Component={SuperBanner}
              componentProps={superBanner}
              componentName="SuperBanner"
              skeletonClassName="skeleton-superbanner"
            />
        )}      
        {hero1 && hero2 && hero3 && (
          <section className="container banner-cards" data-cy="Section heros">
            <div className="banner-cards--content">
              <div className="banner-cards--content_card banner-cards--content_card--one">
                <CustomizerComponent
                  name={hero1.activityName}
                  Component={Card}
                  componentProps={{ ...hero1, setPriority: true }}
                  componentName="BannerCardHero1"
                  skeletonClassName="skeleton-banner-card"
                />
              </div>
              <div className="banner-cards--content_card banner-cards--content_card--two">
                <CustomizerComponent
                  name={hero2.activityName}
                  Component={Card}
                  componentProps={{ ...hero2, setPriority: true }}
                  componentName="BannerCardHero2"
                  skeletonClassName="skeleton-banner-card"
                />
              </div>
              <div className="banner-cards--content_card banner-cards--content_card--three">
                <CustomizerComponent
                  name={hero3.activityName}
                  Component={Card}
                  componentProps={{ ...hero3, setPriority: true }}
                  componentName="BannerCardHero3"
                  skeletonClassName="skeleton-banner-card"
                />
              </div>
            </div>
          </section>
        )}

        {offer1 && offer2 && offer3 && (
          <section className="featuredOfferCards" data-cy="Section offer cards">
            <div className="container featuredOfferCards--content">
              <div className="row">
                <div
                  className="col-xs-12 col-sm-4 col-md-4 col-lg-4 featuredOfferCards--content_cards"
                  key={`card-1`}
                >
                  <CustomizerComponent
                    name={offer1.activityName}
                    Component={Card}
                    componentProps={offer1}
                    componentName={`OfferCard1`}
                    skeletonClassName="skeleton-banner-card"
                  />
                </div>
                <div
                  className="col-xs-12 col-sm-4 col-md-4 col-lg-4 featuredOfferCards--content_cards"
                  key={`card-2`}
                >
                  <CustomizerComponent
                    name={offer2.activityName}
                    Component={Card}
                    componentProps={offer2}
                    componentName={`OfferCard2`}
                    skeletonClassName="skeleton-banner-card"
                  />
                </div>
                <div
                  className="col-xs-12 col-sm-4 col-md-4 col-lg-4 featuredOfferCards--content_cards"
                  key={`card-3`}
                >
                  <CustomizerComponent
                    name={offer3.activityName}
                    Component={Card}
                    componentProps={offer3}
                    componentName={`OfferCard3`}
                    skeletonClassName="skeleton-banner-card"
                  />
                </div>
              </div>
            </div>
          </section>
        )}

        {r2r && <DevicesOffers title={r2rTitle} dispoData={r2r} />}
        {categories && (
          <div className="featured-carousel-categories container">
            <CustomizerComponent
              name={categories.activityName}
              Component={FeaturedCarousel}
              componentName="categorias"
              componentProps={categories}
            />
          </div>
        )}

        {brands && (
          <div className="featured-carousel-brands container">
            <CustomizerComponent
              name={brands.activityName}
              Component={FeaturedCarousel}
              componentName="brands"
              componentProps={brands}
            />
          </div>
        )}
        {faqs && (
          <div className="container faqs">
            <CustomizerComponent
              name={faqs.activityName}
              Component={ExpandableList}
              componentName="Faqs BF"
              componentProps={faqs}
            />
          </div>
        )}
        <Footer footerProps={footerProps} />
        <style jsx>
          {`
            .banerSup {
              padding: 1rem 0;
            }
            .banner-cards {
              padding-top: 1rem;

              :global(.card.layout-capta) {
                padding-top: 75%;
              }
              :global(.card.layout-capta .card-content--price) {
                display: block;
              }
              :global(.price.price-layout--default) {
                display: inline-block;
                margin-right: 0.5rem;
              }
              :global(.price.price-layout--compact) {
                display: inline-flex;
                margin-right: 0.5rem;
              }

              :global(.price--post-price) {
                margin-top: 0.5rem;
              }
              :global(.capta-price--mobile) {
                min-height: 1.5rem;
              }
              :global(.card.layout-product .card-container--label) {
              }
              :global(.card.layout-product .card-container--label--zero) {
                min-height: auto;
              }

              :global(.card.layout-product .card-container) {
                flex-direction: column;
                justify-content: flex-start;
              }
              :global(.card.layout-product .card-content--price) {
              }

              :global(.card.layout-product .card-header--subtitle) {
              }

              :global(.card.layout-capta .card-header--subtitle) {
                display: block;
              }
              :global(.card.layout-dispo-product .card-container) {
                flex-direction: column;
              }
              :global(.card.layout-dispo-product .card-container--label) {
                :global(.label) {
                  margin-bottom: 0.25rem;
                }
              }
              :global(.card.layout-dispo-product .card-content--price) {
              }
              :global(.card.layout-dispo-product) {
                padding: 5%;
              }
              :global(.card) {
                padding: 0;
                :global(.card-container) {
                  gap: 0;
                }
                :global(.card-container--image .custom-image) {
                  border-radius: 0;
                }

                :global(.card-container--info) {
                  padding: 5%;
                  :global(.card-container--label) {
                  }
                }

                :global(.card-container--image) {
                  max-width: none;
                  aspect-ratio: unset;
                  padding-top: 75%;
                }
              }

              :global(.card.layout-dispo-product .card-container--info) {
                padding: 0;
              }
              &--content {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin: 0 auto;
                justify-content: space-between;

                &_card {
                  padding: 0;
                  position: relative;
                  display: flex;
                  width: 100%;
                }

                &--two,
                &--three {
                  display: none !important;
                }
              }

              /* Tablet */
              @media screen and (min-width: 768px) {
                margin: 0 auto;
                padding-top: 1rem;
                padding-bottom: 1rem;
                :global(.card.layout-capta) {
                  padding-top: 0;
                }
                :global(.card.layout-product .card-header--pretitle) {
                  display: block;
                }
                :global(.card.layout-product .card-header--subtitle) {
                  display: block;
                }
                :global(.card.layout-product .card-content--price) {
                  display: block;
                }
                :global(.card.layout-dispo-product .card-content--price) {
                  display: block;
                }
                &--content {
                  flex-wrap: nowrap;
                  gap: 1rem;
                }
                :global(.card.layout-product .card-container--label--zero) {
                  min-height: auto;
                }
              }

              @media screen and (min-width: 1280px) {
                margin: 0 auto;
                padding-top: 1rem;
                padding-bottom: 1rem;
                &--content {
                  flex-wrap: nowrap;
                  gap: 1.5rem;
                }
              }
            }

            .featuredOfferCards {
              padding-top: 0;
              padding-bottom: 1rem;
              justify-content: center;
              flex-direction: column;
              line-height: 29px;
              :global(h1) {
                letter-spacing: -0.5px;
                padding-bottom: 1rem;
              }

              :global(.card.layout-product .card-container--label) {
              }
              :global(
                  .card.layout-product
                    .card-container
                    .card-content--price-block
                ) {
                display: flex;
                gap: 0.5rem;
              }
              :global(.card) {
                padding: 0;
                :global(.card-container) {
                  gap: 0;
                }
                :global(.card-container--image .custom-image) {
                  border-radius: 0;
                }

                :global(.card-container--info) {
                  padding: 1.5rem;
                  gap: 1rem;
                  :global(.card-container--label) {
                  }
                }
                :global(.card-container--image) {
                  max-width: none;
                  aspect-ratio: unset;
                }
                :global(img) {
                  object-fit: cover !important;
                }
              }
              &--content {
                line-height: normal;
                &_cards {
                  position: relative;
                  display: flex;
                  flex-wrap: wrap;
                }
                .row {
                  grid-row-gap: 1rem;
                  align-items: stretch;
                }
              }
            }
            @media screen and (max-width: 767px) {
              .featuredOfferCards {
                :global(.card-column .capta-price--mobile) {
                  display: none;
                }
              }
            }
            @media screen and (min-width: 768px) {
              .featuredOfferCards {
                :global(.card) {
                  :global(.card-container) {
                    gap: 0;
                  }
                  :global(.card-container--image) {
                    padding-top: 75%;
                  }
                  :global(img) {
                    object-fit: cover !important;
                  }
                }
                &--content {
                  padding-bottom: 0.5rem;
                  .row {
                    grid-row-gap: 1rem;
                  }
                }
                :global(.card.layout-product .card-container--label) {
                  min-height: 2rem;
                }
                :global(.card .layout-tariff) {
                  :global(.card-container--info) {
                    :global(.card-container--label) {
                      min-height: auto;
                    }
                  }
                }
              }
            }
            .featured-carousel-categories {
              margin-top: 1rem;
              :global(.carousel-slide) {
                width: 16rem;
                height: 100%;
                background-color: white;
                border: none;
                border-radius: 16px;
                position: relative;
                padding: 0.5rem;
                cursor: pointer;

                :global(.img-container) {
                  border: solid #eeeeee 1px;
                  border-radius: 16px;
                }
                :global(.carousel-slide-title) {
                  margin-top: 1.5rem;
                }
                :global(.text) {
                  line-height: 1.5rem;
                  text-align: left;
                }
              }

              .carousel-slide:hover {
                border: none;
              }
            }

            :global(.device-offers) {
              background-color: #ecebeb;

              padding-top: 1.5rem !important;
              padding-bottom: 1rem !important;
              @media screen and (max-width: 767px) {
                :global(.device-services--title){
                  flex-direction: column;
                  align-items: flex-start;
                }
              }

              :global(.store-link) {
                display: flex;
                flex-flow: row;
                -webkit-box-align: center;
                align-items: center;
                gap: 0.375rem;
                & > :global(.svg-layout-size) {
                  transition: transform 200ms ease-in-out;
                }

                &:hover {
                  & > :global(.svg-layout-size) {
                    transform: translateX(0.5rem);
                  }
                }
              }
            }

            .faqs {
              margin-top: 2rem;
              margin-bottom: 2rem;
            }
          `}
        </style>
      </>
    );
  }
}

export default BF;

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  return getStaticPropsMethod(data, "", 1, {
    pathname: "/black-friday",
    orionAlias: null,
    seoLocation: "www.movistar.es/black-friday",
    headerLocation: "/black-friday",
    layout: "black-friday",
    custoPageName: "black-friday-24",
  });
});
